/*
 * @Author: YuanYuan
 * @Date: 2024-05-29 14:11:33
 * @LastEditTime: 2025-08-22 14:00:58
 * @Description: 非网站接入接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'tableQuery',
    path: `${prefix}/tcpDomain/list`,
    method: 'get',
    params: {
      page: 1,
      limit: 10,
      packageId: '',
      accessProtocol: '',
      loadBalance: '',
      accessPort: '',
      startDate: '',
      endDate: ''
    },
    desc: '非网站接入列表'
  },
  {
    name: 'ruleAdd',
    path: `${prefix}/tcpDomain/add`,
    method: 'post',
    params: {
      accessProtocol: '',
      accessPort: '',
      sourcePort: '',
      source: '',
      loadBalance: '',
      packageId: ''
    },
    desc: '新增规则'
  },
  {
    name: 'ruleUpdate',
    path: `${prefix}/tcpDomain/update`,
    method: 'post',
    params: {
      accessProtocol: '',
      accessPort: '',
      sourcePort: '',
      source: '',
      loadBalance: '',
      packageId: '',
      id: ''
    },
    desc: '更新规则'
  },
  {
    name: 'changeOrigin',
    path: `${prefix}/tcpDomain/batchUpdate`,
    method: 'post',
    params: {
      source: '',
      params: [],
      packageId: ''
    },
    desc: '换源'
  },
  {
    name: 'ruleBatchAdd',
    path: `${prefix}/tcpDomain/batchAdd`,
    method: 'post',
    params: {
      tcpInfo: '',
      packageId: ''
    },
    desc: '批量新增规则'
  },
  {
    name: 'ruleDelete',
    path: `${prefix}/tcpDomain/delete`,
    method: 'post',
    params: {
      packageId: '',
      params: []
    },
    desc: '删除规则'
  }
]
